export default __webpack_public_path__ + "static/media/credit-card.3db6cece.svg";